<template>
  <div class="questionnaire">
		<div class="questionnaire-banner"><img src="../../assets/images/questionnaire-banner.png"></div>
		<div class="container-wrap-s" v-if="userType == '01' && data.hasWritten == false && data.orderFinished == false && data.quizs.length">
			<div class="questionnaire-choice" v-for="(quiz, index) in data.quizs" :key="quiz.quizId">
				<div class="num-title"><span>{{leftPad(index+1)}}</span>/{{data.quizs.length}} {{quizType(quiz.type)}}</div>
				<div class="title">{{quiz.name}}</div>
				<div class="skill-set" v-if="quiz.type == 1 || quiz.type == 2">
					<div class="skill-item" :class="answer[index].value.indexOf(opt.itemId) > -1? 'active':''" v-for="opt in quiz.optionals" :key="opt.itemId" @click="choseAns(quiz, opt, index)">
						<div class="skill-item-name">{{opt.name}}</div>
					</div>
				</div>
				<div class="questionnaire-textarea" v-if="quiz.type == 4">
					<textarea rows="6" maxlength="150" placeholder="" v-model="answer[index].value[0]"></textarea>
					<div class="num-counter"><span id="num">{{answer[index].value.length?answer[index].value[0].length:0}}</span>/150</div>
				</div>
			</div>
		</div>
		<div class="container-wrap-s" v-else>
			<div class="questionnaire-choice" v-for="(quiz, index) in data.quizs" :key="quiz.quizId">
				<div class="num-title"><span>{{leftPad(index+1)}}</span>/{{data.quizs.length}} {{quizType(quiz.type)}}</div>
				<div class="title">{{quiz.name}}</div>
				<div class="skill-set" v-if="quiz.type == 1 || quiz.type == 2">
					<div class="skill-item" :class="opt.selected == 1? 'active':''" v-for="opt in quiz.optionals" :key="opt.itemId">
						<div class="skill-item-name">{{opt.name}}</div>
					</div>
				</div>
				<div class="questionnaire-textarea" v-if="quiz.type == 4">
					<textarea rows="6" maxlength="150" placeholder="" v-model="quiz.value" disabled></textarea>
					<div class="num-counter"><span id="num">{{quiz.value? quiz.value.length:0}}</span>/150</div>
				</div>
			</div>
		</div>
		<div class="questionnaire-filled"></div>
		<div class="questionnaire-btn" v-if="data.hasWritten == false && userType == '01' && data.orderFinished == false"><a href="javascript:;" @click="submitAns">提交</a></div>
	</div>
</template>
<script>
import * as $services from "@/services/index";
export default {

  data() {
    return {
			data: {
				quizs: []
			},
			answer: [],
			orderNo: "",
			userType: "",
			record: {}
    };
  },

  created() {
		this.orderNo = this.$route.query.orderNo || "";
		this.userType = this.$route.query.userType || "";
		this.getQuestions();
		//this.getConsultInfo();
  },
  methods: {
		//查询订单详情
		async getConsultInfo() {
			let res = await this.$http.getConsultInfoByOrderNo({
				orderNo: this.orderNo,
				userType: this.userType
			})
			this.record = res.record;
		},
		//获取题目
		async getQuestions() {
			let res = await this.$http.questions({
				bizId: this.orderNo,
			})
			res.quizs = res.quizs.filter(quiz => ["1", "2", "4"].indexOf(quiz.type) > -1) //过滤星题
			this.data = res;
			const answer = []
			res.quizs.forEach(quiz => {
				answer.push({
					quizId: quiz.quizId,
					value: []
				})
			})
			this.answer = answer;
		},
		//选择答案
		choseAns(quiz, opt, index) {
			const answer = this.answer;
			if (quiz.type == '1') { //多选
				let ansArr = answer[index].value;
				let optIdx = ansArr.indexOf(opt.itemId);
				if (optIdx > -1) {
					ansArr.splice(optIdx, 1);
				} else {
					ansArr.push(opt.itemId);
				}
			} else if (quiz.type == '2') {//单选
				answer[index].value = [opt.itemId];
			}
			this.answer = answer;
		},
		//提交
		async submitAns() {
			let param = {
				templateId: this.data.templateId,
				bizId: this.orderNo
			}
			let isComplete = true;
			const answer = JSON.parse(JSON.stringify(this.answer));
			param.quizs = answer.map(ans => {
				if (!ans.value.length) {
					isComplete = false;
				} else {
					ans.value = ans.value.join("#");
				}
				return ans;
			})
			if (!isComplete) {
				this.$toast("请将问卷填写完整！");
				return;
			}
			this.$messagebox({
        title: "温馨提示",
        message:
          "确认以上所回答信息属实、无误并提交",
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "提交"
      }).then(action => {
        if (action === "confirm") {
          this.$http.submitQuiz(param).then(res => {
						this.$toast("提交成功！")
						// this.getQuestions();
						const isApp = this.isApp();
						if (!isApp) {
							this.$router.go(-1);
						} else {
							this.setupWebViewJavascriptBridge(function(bridge) {
								//调用APP方法
								bridge.callHandler(
									"YHJavaScriptCallHandler",
									{
										"method": "submitQuestion"
									},
									function(response) {
										console.log("IOS back data:", response);
									}
								);
							});
						}
					})
        }
      });
		},
		//判断是否我们自己APP内调用
    isApp() {
      var _userAgent = navigator.userAgent;
      return _userAgent.indexOf("COM_MSTPAY") > -1;
		},
		//调用app
		setupWebViewJavascriptBridge(callback) {
      if (window.WebViewJavascriptBridge) {
        return callback(WebViewJavascriptBridge);
      }
      if (window.WVJBCallbacks) {
        return window.WVJBCallbacks.push(callback);
      }
      window.WVJBCallbacks = [callback];
      var WVJBIframe = document.createElement("iframe");
      WVJBIframe.style.display = "none";
      WVJBIframe.src = "https://__bridge_loaded__";
      document.documentElement.appendChild(WVJBIframe);
      setTimeout(function() {
        document.documentElement.removeChild(WVJBIframe);
      }, 0);
    },
		//补零
		leftPad(n) {
			return parseInt(n)<10? '0'+n : n;
		},
		//题目类型
		quizType(type) {
			const obj = {
				1: '多选题',
				2: '单选题',
				3: '星级题',
				4: '文本题'
			}
			return obj[type]? obj[type]:"";
		}
  }
};
</script>




// WEBPACK FOOTER //
// src/components/patientEnd/questionnaire.vue